/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/object-orientation/object-orientation',['require','underscore','core/base-screen','markdown','jqueryui','touchpunch'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  //var $ = require('jquery');
  var BaseScreen = require('core/base-screen');

  var markdown = require('markdown');
  require('jqueryui');
  require('touchpunch');

  /*****************************************************************************************************************///}

  var ObjectOrientation = BaseScreen.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    magnification: 1,
    attempts: 0,
    maxAttempts: 3,
    clickCoordinates: { x: 0, y: 0 },
    zoomed: false,

    events: {
      'click .submit-btn': 'submitPressed',
      'click .zoom': 'zoomPressed',
      'click .exit-small': 'closePressed'
    },

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    setContent: function()
    {
      BaseScreen.prototype.setContent.apply(this);

      // set some default parameters

      if (!this.content.get('coordinates'))
      {
        this.content.set('coordinates', {
          x: 72,
          y: 470,
          angle: 180
        });
      }

      if (!this.content.get('buffer'))
      {
        this.content.set('buffer', {
          x: 25,
          y: 25,
          angle: 10
        });
      }
    },

    onShow: function()
    {
      this.playMedia({ callback: this.onMediaEnded });

      this.$el.find('.drag').draggable({
        containment: '[data-role=content] .contain',
        cursor: 'move',
        scroll: false
        //start: $.proxy(this.onObjectStartDrag, this)
        //drag: $.proxy(this.onObjectDrag, this)
      });

      this.$el.find('.rotate').rotatable();
    },

    onMediaEnded: function(e)
    {
      //console.log('onMediaEnded');
    },

    onObjectStartDrag: function(e, ui)
    {
      this.clickCoordinates.x = e.clientX;
      this.clickCoordinates.y = e.clientY;
    },

    onObjectDrag: function(e, ui)
    {
      ui.position = {
        left: (e.clientX - this.clickCoordinates.x + ui.originalPosition.left) / this.magnification,
        top:  (e.clientY - this.clickCoordinates.y + ui.originalPosition.top) / this.magnification
      };
    },

    zoomPressed: function(e)
    {
      //console.log('zoomPressed');

      this.zoomed = !this.zoomed;

      this.$el.find('.ruler').toggleClass('zoomed', this.zoomed);
      this.$el.find('.bench').toggleClass('zoomed', this.zoomed);
      this.$el.find('.zoom').toggleClass('zoom-in', !this.zoomed);
      this.$el.find('.zoom').toggleClass('zoom-out', this.zoomed);

      this.magnification = this.zoomed ? 1 : 0.4;
    },

    closePressed: function(e)
    {
      this.$el.find('.feedback').hide();
    },

    submitPressed: function(e)
    {
      //console.log('submitPressed');

      var feedback;
      var correct = this.evaluate();

      this.attempts++;

      if (correct) // correct
      {
        feedback = this.content.get('feedback').correct;

        this.finish();
      }
      else if (this.attempts >= this.maxAttempts) // too many attempts
      {
        feedback = this.content.get('feedback')['final'];

        this.finish();

        this.showAnswer();
      }
      else // incorrect
      {
        feedback = this.content.get('feedback').incorrect;
      }

      // show feedback
      if (feedback)
      {
        this.$el.find('.feedback-text').html(markdown.toHTML(feedback));
        this.$el.find('.feedback').show();
      }

      return false;
    },

    evaluate: function()
    {
      var obj = this.$el.find('.object');

      var objCoordinates = { };

      objCoordinates.x = obj.position().left;
      objCoordinates.y = obj.position().top;
      objCoordinates.angle = this.getRotationDegrees(obj.find('.rotate'));

      var target = this.content.get('coordinates');
      var buffer = this.content.get('buffer');

      var mag = (this.zoomed) ? 0.4 : 1;

      var correct = _.every(objCoordinates, function(value, key)
      {
        var mod = (key !== 'angle') ? mag : 1;
        var high = (target[key] + buffer[key]) / mod;
        var low = (target[key] - buffer[key]) / mod;
        //console.log(key + ': ' + high + ' | ' + value + ' | ' + low);
        return (value >= low && value <= high);
      });

      return correct;
    },

    showAnswer: function()
    {
      var target = this.content.get('coordinates');
      var obj = this.$el.find('.object');

      obj.css(obj.position());
      obj.css({ bottom: 'auto' });

      obj.animate({ left: target.x, top: target.y }, 1000);
      obj.find('.rotate').rotatable('performRotation', target.angle, 'deg');
    },

    getRotationDegrees: function(obj)
    {
      var matrix = obj.css('-webkit-transform') ||
      obj.css('-moz-transform')    ||
      obj.css('-ms-transform')     ||
      obj.css('-o-transform')      ||
      obj.css('transform');

      var angle = 0;

      if (matrix !== 'none')
      {
        var values = matrix.split('(')[1].split(')')[0].split(',');
        var a = values[0];
        var b = values[1];
        angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
      }

      return (angle < 0) ? angle += 360 : angle;
    },

    finish: function()
    {
      this.$el.find('.drag').draggable('disable');
      this.$el.find('.rotate').rotatable('disable');

      this.$el.find('.submit-btn').attr('disabled', true);

      BaseScreen.prototype.finish.call(this);
    }

  /*****************************************************************************************************************///}

  });

  return ObjectOrientation;

});

